import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';


const ChartControls = ({ onTimeframeChange, onIndicatorToggle, onDrawingToolSelect, activeIndicators, selectedTimeframe }) => {
  const [isDrawingMode, setIsDrawingMode] = useState(false);

  const timeframeOptions = [
    { value: '1m', label: '1 Minute' },
    { value: '5m', label: '5 Minutes' },
    { value: '15m', label: '15 Minutes' },
    { value: '1h', label: '1 Hour' },
    { value: '4h', label: '4 Hours' },
    { value: '1d', label: '1 Day' },
    { value: '1w', label: '1 Week' },
    { value: '1M', label: '1 Month' }
  ];

  const indicators = [
    { id: 'sma', name: 'SMA', label: 'Simple Moving Average' },
    { id: 'ema', name: 'EMA', label: 'Exponential Moving Average' },
    { id: 'bollinger', name: 'BB', label: 'Bollinger Bands' },
    { id: 'rsi', name: 'RSI', label: 'Relative Strength Index' },
    { id: 'macd', name: 'MACD', label: 'MACD' },
    { id: 'volume', name: 'VOL', label: 'Volume' }
  ];

  const drawingTools = [
    { id: 'line', icon: 'Minus', label: 'Trend Line' },
    { id: 'rectangle', icon: 'Square', label: 'Rectangle' },
    { id: 'circle', icon: 'Circle', label: 'Circle' },
    { id: 'arrow', icon: 'ArrowRight', label: 'Arrow' },
    { id: 'text', icon: 'Type', label: 'Text' }
  ];

  const handleDrawingToolClick = (toolId) => {
    setIsDrawingMode(!isDrawingMode);
    onDrawingToolSelect(toolId);
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-6">
      <div className="flex flex-wrap items-center gap-4">
        {/* Timeframe Selector */}
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium text-foreground">Timeframe:</span>
          <Select
            options={timeframeOptions}
            value={selectedTimeframe}
            onChange={onTimeframeChange}
            className="w-32"
          />
        </div>

        {/* Indicators */}
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium text-foreground">Indicators:</span>
          <div className="flex gap-1">
            {indicators?.map(indicator => (
              <Button
                key={indicator?.id}
                variant={activeIndicators?.includes(indicator?.id) ? "default" : "outline"}
                size="sm"
                onClick={() => onIndicatorToggle(indicator?.id)}
                className="text-xs"
              >
                {indicator?.name}
              </Button>
            ))}
          </div>
        </div>

        {/* Drawing Tools */}
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium text-foreground">Tools:</span>
          <div className="flex gap-1">
            {drawingTools?.map(tool => (
              <Button
                key={tool?.id}
                variant="outline"
                size="sm"
                onClick={() => handleDrawingToolClick(tool?.id)}
                iconName={tool?.icon}
                iconSize={14}
                className="text-xs"
              >
                {tool?.label}
              </Button>
            ))}
          </div>
        </div>

        {/* Chart Actions */}
        <div className="flex items-center gap-2 ml-auto">
          <Button
            variant="outline"
            size="sm"
            iconName="Download"
            iconSize={14}
          >
            Export
          </Button>
          <Button
            variant="outline"
            size="sm"
            iconName="Share"
            iconSize={14}
          >
            Share
          </Button>
          <Button
            variant="outline"
            size="sm"
            iconName="Maximize"
            iconSize={14}
          >
            Fullscreen
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ChartControls;